//// rishab code
import { TagBox, TextBox, Button } from "devextreme-react";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import BreadCrumb from "../../../components/breadCrumb/BreadCrumb";
import CustomDropdown from "../../../components/customDropDown/CustomDropdown";
import CancelSaveHeader from "../../../components/customPageHeader/CancelSaveHeader";
import CustomOtpPopup from "../../../components/customPopup/CustomOtpPopup";
import CustomTextBox from "../../../components/customTextBox/CustomTextBox";
import { custStatusDataSource3 } from "../../customers/data";
import { ToastDisplayer } from "../../../components/toastDisplay/ToastDisplayer";
import { LoadPanel } from "devextreme-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../contexts/auth";
import { editCmpUserApi, getRoles } from "../../../api/companyUserApi";
import { getUserByCodeApi } from "../../../api/companyUserApi";
import AddNewSubHeader from "../../../components/customPageHeader/SaveNewHeader";
import "./EditUsersPage.scss";
export default function EditUsersPage() {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { cmpusercode } = location.state || {};
  const [errors, setErrors] = useState({});
  const [isEditUserOtpPopupVisible, setisEditUserOtpPopupVisible] =
    useState(false);
  // const [roleDataSource, setRoleDataSource] = useState([]);
  const { user } = useAuth();
  const [formData, setFormData] = useState({
    userCode: "",
    userName: "",
    email: "",
    // password: "",
    contactNumber: "",
    status: "",
    // passwordreq: "",
    companytransid: user?.companytransid,
    isDel: "",
    // roles: [],
  });

  //API to fetch data using userCode:->
  // useEffect(() => {
  //   if (!cmpusercode) return;

  //   const loadData = async () => {
  //     try {
  //       setLoading(true);

  //       // // Run APIs in parallel
  //       // const [rolesRes, userRes] = await Promise.all([
  //       //   getRoles(),
  //       //   getUserByCodeApi(cmpusercode),
  //       // ]);

  //       // // ✅ Set Roles
  //       // if (Array.isArray(rolesRes)) {
  //       //   setRoleDataSource(rolesRes);
  //       // } else {
  //       //   setRoleDataSource([]);
  //       // }

  //       // ✅ Validate User Response
  //       const userData = userRes?.data?.data;

  //       if (!userData) {
  //         ToastDisplayer("error", "Unable to load user data");
  //         return;
  //       }

  //       // ✅ Map User Data Properly
  //       setFormData({
  //         userCode: userData.cmpusercode || "",
  //         userName: userData.cmpuserusername || "",
  //         email: userData.cmpuseremail || "",
  //         password: "",
  //         contactNumber: userData.cmpusercontactnumber || "",
  //         status: userData.cmpuserstatus === "active" ? "A" : "I",
  //         // passwordreq: userData.passwordreq || "",
  //         companytransid: user?.companytransid,
  //         isDel: userData.cmpuserisdeleted || 0,

  //         // // ✅ Correct Role Mapping
  //         // roles: Array.isArray(userData.role_details)
  //         //   ? userData.role_details.map((r) => r.transid)
  //         //   : [],
  //       });
  //     } catch (error) {
  //       ToastDisplayer("error", "Failed to load data");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   loadData();
  // }, [cmpusercode]);

  useEffect(() => {
    if (!cmpusercode) return;

    const loadData = async () => {
      try {
        setLoading(true);

        // Fetch user details
        const userRes = await getUserByCodeApi(cmpusercode);

        const userData = userRes?.data?.data;

        if (!userData) {
          ToastDisplayer("error", "Unable to load user data");
          return;
        }

        // Map API data to form
        setFormData({
          userCode: userData.cmpusercode || "",
          userName: userData.cmpuserusername || "",
          email: userData.cmpuseremail || "",
          // password: "",
          contactNumber: userData.cmpusercontactnumber || "",
          status: userData.cmpuserstatus === "active" ? "A" : "I",
          companytransid: user?.companytransid,
          isDel: userData.cmpuserisdeleted || 0,
        });
      } catch (error) {
        ToastDisplayer("error", "Failed to load user data");
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [cmpusercode]);

  const handleInputChange = (field, value) => {
    setFormData((prevData) => {
      let updatedData = { ...prevData, [field]: value };
      if (field === "password") {
        updatedData.passwordreq = "pending";
      }
      if (field === "status") {
        updatedData.status = value.value;
      }
      return updatedData;
    });
  };

  const formValidation = () => {
    const newErrors = {};
    const { userName, email, contactNumber, password, status, passwordreq } =
      formData;

    if (!userName?.trim()) {
      newErrors.userName = "User Name is Required.";
    }
    if (!email?.trim()) {
      newErrors.email = "Email is Required.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = "Invalid Email Format";
    }

    if (!contactNumber?.trim()) {
      newErrors.contactNumber = "Contact Number is Required.";
    } else if (!/^\d{3,15}$/.test(formData.contactNumber)) {
      newErrors.contactNumber =
        "Contact number must be numeric and must be between 3 to 15";
    }

    // if (passwordreq === "pending") {
    //   if (!password?.trim()) {
    //     newErrors.password = "Password is Required.";
    //   } else if (password?.trim() && password.length < 6) {
    //     newErrors.password = "Password must have at least 6 characters.";
    //   } else if (password?.trim() && password.length > 15) {
    //     newErrors.password = "Password must not be greater 15 characters";
    //   }
    // }

    if (!status) {
      newErrors.status = "Status is required.";
    }

    setErrors(newErrors);

    Object.values(newErrors).forEach((error) => {
      ToastDisplayer("error", error);
    });

    return Object.keys(newErrors).length === 0;
  };

  const handleEditUserDetails = async () => {
    if (!formValidation()) return;

    try {
      setLoading(true);

      const modifiedRowData = {
        cmpuserusername: formData.userName,
        cmpuserstatus: formData.status === "A" ? "active" : "inactive",
        cmpusercontactnumber: formData.contactNumber,
        companytransid: formData.companytransid,
        cmpuserisdeleted: formData.isDel,
        // roles: formData.roles,    role commented
      };

      // if (formData.passwordreq === "pending") {
      //   modifiedRowData.cmpuserpassword = formData.password;
      //   modifiedRowData.passwordreq = "changed";
      // }
      const response = await editCmpUserApi(formData.userCode, modifiedRowData);

      if (response) {
        ToastDisplayer("success", "User details updated successfully.");
        navigate("/Developer");
      }
    } catch (error) {
      ToastDisplayer(
        "error",
        Object.entries(error.response?.data?.errors).map(
          ([_, messages]) => messages[0],
        ),
      );
    } finally {
      setLoading(false);
    }
  };

  const handleEditCancel = () => {
    navigate("/Developer");
  };

  const toggleUserEditOtpPopup = () => {
    setisEditUserOtpPopupVisible(!isEditUserOtpPopupVisible);
  };

  return (
    <>
      {loading && <LoadPanel visible={true} />}
      <div className="addCustPage">
        <div className="headerComponent">
          <div className="headerContainer1">
            <div className="title">
              <span class="icon-size">
                <i class="ri-edit-line"></i>
              </span>
              {/* <p>Edit Developer</p> */}
              <BreadCrumb />
            </div>
          </div>
          <div className="headerContainer2">
            <Button
              text="Cancel"
              // icon="add"
              stylingMode="outlined"
              type="default"
              width={140}
              onClick={handleEditCancel}
            />

            <Button
              className="saveBtn"
              text="Save Details"
              // icon="add"
              stylingMode="outlined"
              type="default"
              width={140}
              onClick={handleEditUserDetails}
            />
          </div>
        </div>
        {/* <AddNewSubHeader
          titleName={`Edit User`}
          handleSaveDetails={handleEditUserDetails}
          handleCancel={handleEditCancel}
          cancelText={"Cancel"}
          saveText={"Save Details"}
          iconClass={"ri-edit-line"}
        /> */}
        <div className="customerMain">
          <div className="mainAddCustSection">
            <CustomTextBox
              label="User Code"
              placeholder="What's the code?"
              value={formData.userCode}
              type="text"
              readOnly
            />
            <CustomTextBox
              label="User Name"
              placeholder="What's the name?"
              value={formData.userName}
              onChange={(e) => handleInputChange("userName", e.value)}
              type="text"
            />
            <div className="MyTextBox">
              <label className="TextBoxLabel">
                Email Address <span className="requiredClass">*</span>
              </label>
              <div className="TextBoxWrapper">
                <TextBox
                  value={formData.email}
                  width={"100%"}
                  stylingMode="outlined"
                  className="TextBoxMain"
                  placeholder="Change Email?"
                  mode="text"
                  readOnly
                />
              </div>
            </div>
            {/* {formData.passwordreq === "pending" ? (
              <CustomTextBox
                label="Password"
                placeholder="Change Password"
                type="password"
                value={formData.password}
                onChange={(e) => handleInputChange("password", e.value)}
              />
            ) : (
              <CustomTextBox
                label="Password"
                placeholder="Password not required"
                type="password"
                readOnly
              />
            )} */}
            <CustomTextBox
              label="Contact Number"
              placeholder="Contact Number"
              value={formData.contactNumber}
              onChange={(e) => handleInputChange("contactNumber", e.value)}
              type="text"
            />
            <CustomDropdown
              label={"Status"}
              myDataSource={custStatusDataSource3}
              selectedValue={formData.status}
              placeholder={formData.status === "A" ? "Active" : "Inactive"}
              setSelectedValue={(newStatus) =>
                handleInputChange("status", newStatus)
              }
            />

            {/* <div className="MyTextBox">
              <label className="TextBoxLabel">
                Roles <span className="requiredClass">*</span>
              </label>

              <TagBox
                stylingMode="outlined"
                dataSource={roleDataSource}
                displayExpr="rolename"
                valueExpr="transid"
                value={formData.roles}
                onValueChanged={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    roles: e.value,
                  }))
                }
                placeholder="Select Roles"
                showSelectionControls={true}
                applyValueMode="useButtons"
                searchEnabled={true}
                width="100%"
              />
            </div> */}
          </div>
        </div>
      </div>

      <CustomOtpPopup
        visible={isEditUserOtpPopupVisible}
        onClose={toggleUserEditOtpPopup}
        emailOtp={formData.email}
      />
    </>
  );
}
